module.exports = __webpack_public_path__ + "static/img/2.c1ee835.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/02/2.png
// module id = fgSv
// module chunks = 1